import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';

const LookupTableResults = ({
  searchResults,
  resultsColumns,
  searchQuery,
  updateValue,
  selectedId,
}) => {
  const numResults = searchResults ? searchResults.length : 0;
  const hasResults = numResults > 0;
  const title = hasResults ? `Search results for '${searchQuery}' (found ${numResults} results)` : 'No results found';
  return (
    <div className="v-f-lookup-table-results">
      <h3>{title}</h3>
      {hasResults && (
        <div className="vf-table">
          <div className="vf-table-head-container">
            <div
              className="vf-table-head"
            >
              {resultsColumns.map(({ id, label }) => (
                <div className={`head-item column-${id}`} key={id}>
                  <span className="head-text">{label}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="vf-table-body">
            {searchResults.map(({
              id,
              columnValues,
              value,
            }) => {
              const isSelected = id === selectedId;
              return (
                <div
                  className={`vf-table-row-container${isSelected ? ' selected' : ''}`}
                  key={id}
                >
                  <div
                    className="vf-table-row"
                  >
                    <OptionButton
                      type="button"
                      className="row-button"
                      option={value}
                      onClick={updateValue}
                    >
                      {resultsColumns.map((column) => {
                        const columnId = column.id;
                        const columnValue = columnValues[columnId] || '-';
                        return (
                          <div className={`column-${columnId} row-item`} key={columnId}>
                            <span className="row-item-text" data-tip={columnValue}>
                              {columnValue}
                            </span>
                            <ReactTooltip />
                          </div>
                        );
                      })}
                    </OptionButton>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

// Shape for the search results passed into this component
const lookupTableSearchResultShape = PropTypes.shape({
  // unique identifier for the result row
  // used as key, and to indicate if the result has been selected
  id: PropTypes.string,
  // map of the display values for each column for this row
  columnValues: PropTypes.objectOf(PropTypes.string),
  // value for the field to be sent back to the form
  // this could either be a simple string value or more typically
  // an object representing E.G a relationship
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
});

// shape for the columns passed into this component
const lookupTableColumnShape = PropTypes.shape({
  id: PropTypes.string, // the column id, used for key
  label: PropTypes.string, // the text to display in the column header
});

LookupTableResults.propTypes = {
  searchResults: PropTypes.arrayOf(lookupTableSearchResultShape),
  resultsColumns: PropTypes.arrayOf(lookupTableColumnShape),
  searchQuery: PropTypes.string,
  updateValue: PropTypes.func,
  selectedId: PropTypes.string,
};

export {
  LookupTableResults,
  lookupTableColumnShape,
};
